import routes from '../_routes';

function getNotNullData(obj) {
  const res = {};
  for (const key in obj) {
    const val = obj[key];
    if (val) {
      if (typeof val === 'object') {
        res[key] = getNotNullData(val);
      } else {
        res[key] = obj[key];
      }
    }
  }

  return res;
};

export default formComponents = (Alpine) => {
  Alpine.data("form", () => ({
    clearError(evt) {
      const el = evt.target;
      el.classList.remove("input-error");
      if (this.errors) this.errors[el.name] = '';
    },

    removeListErrors(tag, index) {
      Object.keys(this.errors).forEach((k, i) => {
        const key = `${tag}[${index}]`;
        if (k.indexOf(key) != -1) {
          delete this.errors[k]; 
        }
      });
    },

    openModalStep(key, status = '') {
      if (status === 'waiting') return;

      const modal = this.$refs[key];
      if(modal) modal.showModal();
    },

    init() {
      this.$nextTick(() => {
        [...document.querySelectorAll(".input-error")].forEach((el) => {
          el.classList.remove("input-error");
        });

        Object.keys(this.errors).forEach((k, i) => {
          const el = document.querySelector(`[name='${k}']`);
          if (el) el.classList.add("input-error");
        });

        [...this.$el.querySelectorAll("input")].forEach((input) => {
          input.addEventListener("input", this.clearError.bind(this));
        });

        [...this.$el.querySelectorAll("select")].forEach((input) => {
          input.addEventListener("change", this.clearError.bind(this));
        });
      });
    },
  }));

  Alpine.data("formSubmit2", (id) => ({
    init() {
      if (typeof window.once === 'undefined') {
        if (typeof URLSearchParams !== 'undefined') {
          const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });
          if (params.step) {
            this.stepName = params.step;
          }

          if (params.object_key) {
            this.objectKey = params.object_key;
          }

          if (params.object_id) {
            this.objectID = params.object_id
          }

          window.history.replaceState({}, document.title, window.location.pathname);
        }

        if (this.stepName && this.objectKey && this.objectID) {
          const key = `${this.stepName}`;
          const el = this.$refs[key];
          this.$data[key][`${this.objectKey}`] = this.objectID
          if (el) el.showModal();
        }

        window.once = 1;
      }
    },

    handleServerError(err) {
      console.error(err);
      const errorEvent = new Event("posterr");
      window.dispatchEvent(errorEvent);
    },

    async saveForm() {
      const ref = this.$refs[id];
      await this.submitForm(ref, { validate: false });
    },

    async autofill() {
      const ref = this.$refs[id];
      await this.submitForm(ref, { autofill: true });
    },

    async saveAndNext() {
      const ref = this.$refs[id];
      await this.submitForm(ref, { showNext: true });
    },

    async submitForm(ref, {autofill = false, showNext = false, validate = true} =  {}) {
      if(!ref) {
        this.handleServerError("missing form reference");
        return;
      }

      const formData = new FormData(ref);
      if (!formData) {
        this.handleServerError("failed to create formdata");
        return;
      }

      if (autofill) {
        formData.append("autofill", "true");
      }

      if (showNext) {
        formData.append("show_next", "true");
      }

      if (validate === false) {
        formData.append("skip_validation", "true");
      }

      try {
        const response = await fetch(ref.action, {
          method: "POST",
          credentials: "same-origin",
          body: new URLSearchParams(formData),
        });

        if (response.status != 200) {
          this.handleServerError(response.statusText);
          return;
        }

        if (response.redirected === true) {
          window.location = response.url;
          return;
        }

        const res = await response.json();
        if (res.flash) {
          this.flash = true;
        } else if (res.errors) {
          this.clearErrors();
          this.errors = res.errors;

          Object.keys(res.errors).forEach((k, i) => {
            const el = document.querySelector(`[name="${k}"]`);
            if (el) el.classList.add("input-error");
          });
        }

        if (res.autofill) {
          // clear the errors
          this.clearErrors();
          Object.assign(this.$data, res.autofill);
        }

        if (res.updated && res.updated === true) {
          this.steps = res.steps;
          this.overview = res.overview;
          Object.assign(this.$data, getNotNullData(res.data));

          const el = this.$refs[`${res.key}`];
          if (el) el.close();

          if (res.show_next && res.show_next === true) {
            const el = this.$refs[`${res.next_step}`];
            if (el) el.showModal();
          }
        }

        const okEvent = new Event("postok");
        window.dispatchEvent(okEvent);
      } catch (err) {
        this.handleServerError(err);
      }
    },

    clearErrors() {
      Object.assign(this.$data, { errors: {} });
      [...document.querySelectorAll(".input-error")].forEach((el) => {
        el.classList.remove("input-error");
      });
    },
  }));

  Alpine.data("fileuploads2", () => ({
    uploading: [],

    validateFileType(file, acceptAttr) {
      const acceptedTypes = acceptAttr.split(",").map((type) => type.trim());
      return acceptedTypes.some((type) => {
        if (type.startsWith(".")) {
          return file.name.endsWith(type);
        } else {
          return file.type === type || (type.endsWith("/*") && file.type.startsWith(type.split("/")[0]));
        }
      });
    },

    handleDrop(event, dataFor, fileInput) {
      event.target.classList.remove("dragover");

      const droppedFiles = Array.from(event.dataTransfer.files);
      const validFiles = droppedFiles.filter((file) => this.validateFileType(file, fileInput.accept));

      if (validFiles.length === 0) {
        this.showFileTypeError(event.target.parentElement);
        return;
      }

      this.clearFileTypeError();

      validFiles.forEach((file) => {
        this.startUpload(file, dataFor, fileInput.hasAttribute("multiple"));
      });
    },

    handleFileSelect(event, dataFor) {
      const fileInput = event.target;
      const files = Array.from(fileInput.files);
      const isMultiple = fileInput.hasAttribute("multiple");

      files.forEach((file) => {
        if (this.validateFileType(file, fileInput.accept)) {
          this.startUpload(file, dataFor, isMultiple);
        } else {
          this.showFileTypeError(fileInput.parentElement.parentElement);
        }
      });

      fileInput.value = "";
    },

    startUpload(file, dataFor, isMultiple) {
      const id = crypto.randomUUID();
      this.uploading.push({ id, filename: file.name, progress: 0, error: null });

      const formData = new FormData();
      formData.append("file", file);

      const xhr = new XMLHttpRequest();
      xhr.open("POST", routes.filesBaseURL, true);

      const submitButtons = document.querySelectorAll("button[type='submit']");

      xhr.upload.addEventListener("progress", (e) => {
        if (e.lengthComputable) {
          const upload = this.uploading.find((u) => u.id === id);
          if (upload) {
            upload.progress = Math.round((e.loaded / e.total) * 100);
          }
        }

        if (submitButtons.length > 0 && !submitButtons[0].classList.contains("disabled")) {
          submitButtons.forEach((btn) => {
            btn.classList.add("disabled");
            btn.disabled = true;
          });
        }
      });

      xhr.addEventListener("load", () => {
        this.uploading = this.uploading.filter((u) => u.id !== id);

        submitButtons.forEach((btn) => {
          btn.classList.remove("disabled");
          btn.disabled = false;
        });

        if (xhr.status === 201) {
          const data = JSON.parse(xhr.responseText);
          this.addToDocsArray(dataFor, { filename: file.name, ...data }, isMultiple);
        } else {
          this.uploading.push({ id, filename: file.name, progress: 100, error: "Upload fehlgeschlagen" });
        }
      });

      xhr.addEventListener("error", () => {
        const upload = this.uploading.find((u) => u.id === id);
        if (upload) {
          upload.error = "Netzwerkfehler";
        }

        submitButtons.forEach((btn) => {
          btn.classList.remove("disabled");
          btn.disabled = false;
        });
      });

      xhr.send(formData);
    },

    addToDocsArray(dataFor, file, isMultiple) {
      const input = document.getElementById(dataFor);
      let docs = [];
      try {
        docs = JSON.parse(input.value || "[]");
      } catch (e) {
        docs = [];
      }

      if (!isMultiple) {
        docs = [];
      }

      docs.push(file);
      input.value = JSON.stringify(docs);
      input.dispatchEvent(new Event("change"));
    },

    showFileTypeError(container) {
      this.clearFileTypeError();
      const errEl = document.createElement("span");
      errEl.innerHTML = "Ungültiger Dateityp";
      errEl.classList.add("error", "mt");
      errEl.id = "file-type-error";
      container.appendChild(errEl);
    },

    clearFileTypeError() {
      const errEl = document.querySelector("#file-type-error");
      if (errEl) errEl.remove();
    },
  }));

  Alpine.data("whitelabel", () => ({
    clearError(evt) {
      const el = evt.target;
      el.classList.remove("input-error");
      if (this.errors) this.errors[el.name] = '';
    },

    init() {
      this.$nextTick(() => {
        [...this.$el.querySelectorAll("input")].forEach((input) => {
          input.addEventListener("input", this.clearError.bind(this));
        });
      });
    },

    handleServerError(msg) {
      this.flash = true;
      console.error(msg);
    },

    async autofill(id) {
      await this.post(id, { autofill: true });
    },

    async post(id, { autofill = false } = {}) {
      if(!id) {
        this.handleServerError("missing form id");
        return;
      }

      const ref = document.getElementById(id);
      if (!ref) {
        this.handleServerError("failed to create formdata");
        return;
      }

      const formData = new FormData(ref);
      if (!formData) {
        this.handleServerError("failed to create formdata");
        return;
      }

      if (autofill) {
        formData.append("autofill", "true");
      }

      try {
        const response = await fetch(ref.action, {
          method: "POST",
          credentials: "same-origin",
          body: new URLSearchParams(formData),
        });

        if (response.status !== 200) {
          this.handleServerError(`status code: ${response.status}`);
          return
        }

        const res = await response.json();

        if (res.autofill) {
          this.clearErrors();
          Object.assign(this.$data, getNotNullData(res.data));
        }

        if (res.flash) {
          this.flash = res.flash;
        }

        if (res.errors) {
          this.errors = res.errors;
        }

        if (res.page) {
          this.page = res.page;
        }
      } catch (err) {
        this.handleServerError("failed to post: " + err);
      }

      this.loading = false;
    },

    clearErrors() {
      Object.assign(this.$data, { errors: {} });
      [...document.querySelectorAll(".input-error")].forEach((el) => {
        el.classList.remove("input-error");
      });
    },
  }));
};
